export default __webpack_public_path__ + "static/media/jira.30ddd39282cdd14287a3bbb37c0135ea.svg";